import firebase from 'firebase'
import axios from 'axios';

const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DB_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORE_BUCKET,
    messagingSenderId: process.env.REACT_APP_SENDERID,
    appId: process.env.REACT_APP_APPID,
    measurementId: process.env.REACT_APP_MEASUREMENTID
};

firebase.initializeApp(config);

const uid = process.env.REACT_APP_UID || "test";
const member = firebase.database().ref(`auth/${uid}`);
const skill = firebase.database().ref(`skills/${uid}`);
const experience = firebase.database().ref(`experiences/${uid}`);
const portfolio = firebase.database().ref(`portfolios/${uid}`);
const service = firebase.database().ref(`services/${uid}`);


export const getUser = (callback) => {
    member.on('value', (snapshot) => {
        callback(snapshot.val())
    });
}

export const getSkill = (callback) => {
    skill.on('value', (snapshot) => {
        callback(snapshot.val())
    });
}

export const getExperience = (callback) => {
    experience.on('value', (snapshot) => {
        callback(snapshot.val())
    });
}

export const getPortfolio = (callback) => {
    portfolio.on('value', (snapshot) => {
        callback(snapshot.val())
    });
}

export const getService = (callback) => {
    service.on('value', (snapshot) => {
        callback(snapshot.val())
    });
}


export default axios.create({
    baseURL: `https://portpolio-api.herokuapp.com/`,
});
